export default __webpack_public_path__ + "static/media/fire-protection.9001ebb6.jpg";